// 配置爬虫状态下，不需要去发起的请求
const map = {};
export default function ({ url = '', method = 'get' }) {
    url = url.split('?')[0];
    let m = map[url];
    if (m === 'all') {
        return true;
    }
    if (m === method) {
        return true;
    }
    return false;
}
